"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iDateFromString = exports.DateFromStringType = void 0;
const t = require("io-ts");
class DateFromStringType extends t.Type {
    constructor() {
        super('Date', (v) => v instanceof Date, (v, c) => t.string.validate(v, c).chain((s) => {
            const d = new Date(s);
            return isNaN(d.getTime()) ? t.failure(s, c) : t.success(d);
        }), t.identity);
        this.tag = 'DateFromStringType';
    }
}
exports.DateFromStringType = DateFromStringType;
exports.iDateFromString = new DateFromStringType();
//# sourceMappingURL=date.js.map